import { DEFAULT_LEVERAGE } from '@ui/constants/uiConfig';

import { formatLeverage } from '../components/TradeModule/utils/formatLeverage';
import { createPersistValue } from './createPersistValue';

export const useLeverageValue = createPersistValue<number>(
  'trade.leverage',
  DEFAULT_LEVERAGE,
);

export const useLeverage = (): number => {
  const leverageValue = useLeverageValue((s) => s._persistValue);
  if (leverageValue <= 0) {
    return DEFAULT_LEVERAGE;
  }
  
return parseFloat(formatLeverage(leverageValue ?? DEFAULT_LEVERAGE));
};